// Generated by CoffeeScript 1.12.7
(function () {
  var BlocksVisualization,
    KeenDataViz,
    bind = function (fn, me) {
      return function () {
        return fn.apply(me, arguments);
      };
    };

  KeenDataViz = require("keen-dataviz")["default"];

  module.exports = BlocksVisualization = (function () {
    BlocksVisualization.prototype.chart = null;

    function BlocksVisualization(createUi, eventData, options) {
      if (options == null) {
        options = {};
      }
      this.renderChart = bind(this.renderChart, this);
      this.ui = createUi(require("Analytics/Visualizations/Blocks/Blocks.html"), {
        blocks: [],
        loaded: false,
        averages: options.averages,
        $onElementRendered: (function (_this) {
          return function (elem) {
            var promise;
            if (options.averages) {
              promise = eventData.getAverageBlockViewDurations();
            } else {
              promise = eventData.getTotalBlockViewDurations(options.groupViews);
            }
            return promise.then(function (blocks) {
              var total;
              total = blocks.reduce(function (previous, block) {
                return previous + block.viewDuration;
              }, 0);
              blocks = blocks.map(function (block) {
                return {
                  title: block.title,
                  viewDuration: block.viewDuration,
                  percentage: (block.viewDuration / total) * 100,
                };
              });
              _this.ui.blocks = blocks;
              _this.ui.loaded = true;
              return _this.renderChart(blocks, elem);
            });
          };
        })(this),
      });
    }

    BlocksVisualization.prototype.renderChart = function (data, elem) {
      var container;
      if (data && data.length > 0) {
        container = $(elem).find(".chart--block-views")[0];
        return (this.chart = new KeenDataViz({
          container: container,
          type: "pie",
          pie: {
            label: {
              threshold: 0.1,
            },
          },
          legend: {
            show: false,
          },
          tooltip: {
            format: {
              value: (function (_this) {
                return function (value, ratio, id, index) {
                  var percentage;
                  percentage = (ratio * 100).toFixed(1);
                  return percentage;
                };
              })(this),
            },
          },
        })
          .data({
            result: data,
          })
          .render());
      }
    };

    return BlocksVisualization;
  })();
}.call(this));
